var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterYtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5177 7.1538v10.0804l8.8957-5.0244-8.8957-5.056Zm19.8175-3.2233C34 6.6166 34 12.1467 34 12.1467s0 5.53-.6648 8.216c-.3799 1.4852-1.5512 2.6229-3.0075 2.9705-2.6592.6952-13.3277.6952-13.3277.6952s-10.6685 0-13.3277-.6952c-1.4563-.3476-2.6276-1.4853-3.0075-2.9705C0 17.6766 0 12.1466 0 12.1466s0-5.53.6648-8.216C1.0447 2.4453 2.216 1.2446 3.6723.8969 6.3315.2017 17 .2017 17 .2017s10.6685 0 13.3277.6952c1.4563.3476 2.6276 1.5484 3.0075 3.0337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYtIcon);
export default __webpack_public_path__ + "static/media/footer-yt-icon.9d1d7364f6c2cc92f5783cb71e9656c1.svg";
export { ForwardRef as ReactComponent };